import React from "react";
import Carousel from "nuka-carousel";
import get_date from "actions/get_announcement";
import arrowRight from "./../../media/slider-right-arrow.svg";
import arrowLeft from "./../../media/slider-left-arrow.svg";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Col } from "Components";
import { baseUrl } from "env";
import { Link } from "react-router-dom";
var Decorators = [
  {
    component: class Prev extends React.PureComponent {
      render() {
        return (
          <button
            className="carousel-left carousel-button"
            circular
            onClick={this.props.previousSlide}
          >
            <img alt="" src={arrowLeft} />
          </button>
        );
      }
    },
    position: "CenterLeft",
    style: {
      padding: 20
    }
  },
  {
    component: class Prev extends React.PureComponent {
      render() {
        return (
          <button
            circular
            className="carousel-right carousel-button"
            icon="chevron right"
            onClick={this.props.nextSlide}
          >
            <img alt="" src={arrowRight} />
          </button>
        );
      }
    },
    position: "TopRight",
    style: {
      padding: 20
    }
  }
];
class Announcement extends React.PureComponent {
  async componentDidMount() {
    await this.props.get_date();
  }
  render = () => (
    <div className="announcement">
      <div className="container row">
        <p className="page_title">Duyurular</p>
        <div className="slider_wrapper">
          <Carousel slidesToShow={1} decorators={Decorators}>
            {this.props.data.map(item => (
              <div key={item.id} className="container carousel_item">
                <div className="row">
                  <Col l={6} m={12}>
                    <p className="title">{item.title}</p>
                    <p className="sub_title">{item.description}</p>
                    <Link to={`/announcement/${item.id}`}>
                      <span>Devamı için tıklayın..</span>
                    </Link>
                  </Col>
                  <Col l={6} m={12}>
                    <div
                      alt=""
                      className="item_thumbnail"
                      style={{
                        backgroundImage: `url(${baseUrl}/api/media/media/${item.media_id})`
                      }}
                    />
                  </Col>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  data: state.announcements ? state.announcements.data : []
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_date
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Announcement);
